var winWidth = $(window).width();

if ( $('.team--item').length > 0 ) {

	$('.team--item-link').on('click',function(e) {

		e.preventDefault();
		var href     = $(this).attr('href');
		var category = $('#team-filter--category').val();
		var query    = '';

		if ( category ) {

			query    = '?';

			if ( category ) {
				query += '&category=' +category;
			}

			href = href + query;

		}

		if (history.pushState) {
			var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + query;
			window.history.pushState({path:newurl},'',newurl);
		}

		window.location.href = href;

	});

}

if ( $('.team--dropdown').length > 0 ) {

  $('.team--dropdown').on('change', function(e) {
    e.preventDefault();
    filterTeam();
  });

}

function filterTeam() {

  $('#team--search-input').val("");

  var classesArray          = [];
  var teamItems             = $('.team--item');
  var sectionTitleExecCmtee = false;
  var sectionTitleSnrLdr    = false;
  var sectionTitleAllStf    = false;

  $('.team--dropdown').each(function(){

    var selectClass = $(this).val();

    if (selectClass) {
      classesArray.push(selectClass);
    }

  });

  if (classesArray.length > 0) {

    teamItems.each(function() {

      var shouldHide = false;
      var teamItem  = $(this);

      $.each(classesArray, function(i,val) {

        if ( !teamItem.hasClass(val) ) {
          shouldHide = true;
        }

      });

      if (shouldHide) {
        $(this).addClass('is-hiding');
      } else {
        $(this).removeClass('is-hiding');
      };

    });

    if ( sectionTitleExecCmtee ) {
      $('#team--item-section__executive-committee').removeClass('is-hiding');
    } else {
      $('#team--item-section__executive-committee').addClass('is-hiding');
    }

    if ( sectionTitleAllStf ) {
      $('#team--item-section__all-staff').removeClass('is-hiding');
    } else {
      $('#team--item-section__all-staff').addClass('is-hiding');
    }

  } else {

    teamItems.removeClass('is-hiding');
    $('.team--item-section').removeClass('is-hiding');

  }

  teamItems.addClass('over');

}

function searchTeam( value ) {

  var tagValue              = value.replace(/[^a-z0-9]/gi, '-');
  tagValue                  = tagValue.replace('--', '-');
  var teamItems             = $('.team--item');
  var sectionTitleExecCmtee = false;
  var sectionTitleAllStf    = false;

	if (tagValue && tagValue.length > 2) {

		teamItems.each(function() {

			var shouldHide = false;
			var teamItem   = $(this);
      var tags       = teamItem.data('searchtags');

			if ( !tags.includes(tagValue) ) {
				shouldHide = true;
			}

			if (shouldHide) {
				$(this).addClass('is-hiding');
			} else {

				$(this).removeClass('is-hiding').addClass('over');

        if ( $(this).hasClass('executive-committee') ) {
          sectionTitleExecCmtee = true;
        } else if ( $(this).hasClass('all-staff') ) {
          sectionTitleAllStf = true;
        }

			};

		});

    if ( sectionTitleExecCmtee ) {
      $('#team--item-section__executive-committee').removeClass('is-hiding');
    } else {
      $('#team--item-section__executive-committee').addClass('is-hiding');
    }

    if ( sectionTitleAllStf ) {
      $('#team--item-section__all-staff').removeClass('is-hiding');
    } else {
      $('#team--item-section__all-staff').addClass('is-hiding');
    }

	} else {

		teamItems.removeClass('is-hiding');
    $('.team--item-section').removeClass('is-hiding');

  }

}

$('.team--item-link').on('click',function(e) {

  e.preventDefault();

  var modal     = $('.team-modal');
  var modalWrap = $('.team-modal-wrap');
  var id        = $(this).data('id');

  $.ajax({
    type     : "post",
    dataType : "json",
    url      : localized_object.ajax_url,
    data : {
      action : "get_team_modal",
      id     : id,
      nonce  : localized_object.nonce
    },
    //processData: false,
    timeout    : 300000,
    beforeSend : function() {
      //grid.addClass('is-loading');
    }
  }).done( function( response ) {

    //grid.removeClass('is-loading');
    //console.log(response);

    if ( response && typeof response.modal !== 'undefined' ) {

      modalWrap.html(response.modal);
      modal.addClass('is-open');

    }

  }).fail(function(xhr, status, error) {
    //Ajax request failed.
    console.log(error);
    var errorMessage = xhr.status + ': ' + xhr.statusText
    console.log('Error - ' + errorMessage);

  }).always(function() {



  });

});

$('.team-modal-close').on('click',function(e) {

  e.preventDefault();
  $('.team-modal').removeClass('is-open');

});

